export type FeedbackSentiment = 'positive' | 'negative';

export enum FeedbackCategory {
    NONE = 'NONE',
    UI_BUG = 'UI_BUG',
    NOT_FACTUALLY_CORRECT = 'NOT_FACTUALLY_CORRECT',
    INCOMPLETE_INFORMATION = 'INCOMPLETE_INFORMATION',
    DID_NOT_FOLLOW_REQUEST = 'DID_NOT_FOLLOW_REQUEST',
    OTHER = 'OTHER',
}

export interface BrowserMetadata {
    userAgent?: string;
    pageUrl?: string;
    clientTimestamp?: string;
    timeZone?: string;
    screenWidth?: number;
    screenHeight?: number;
    viewportWidth?: number;
    viewportHeight?: number;
    browserName?: string;
    browserVersion?: string;
    osName?: string;
    osVersion?: string;
}

export interface FeedbackFormData {
    sentiment: FeedbackSentiment;
    category?: FeedbackCategory;
    comment?: string;
}

/** What a rating is of: an AI chat answer, or an "Improve with AI" answer in the timecard forms. */
export type FeedbackSource = 'AI_CHAT' | 'IMPROVE';

interface FeedbackRating extends BrowserMetadata {
    sentiment: FeedbackSentiment;
    category?: FeedbackCategory;
    comment?: string;
}

/** A rating of an AI chat answer; the backend reads no source as this one. */
export interface ChatFeedbackCreateDto extends FeedbackRating {
    source?: 'AI_CHAT';
    aiChatMessageId: number;
}

/** A rating of an "Improve with AI" answer, which has no chat message. */
export interface ImproveFeedbackCreateDto extends FeedbackRating {
    source: 'IMPROVE';
    /** Null for a timecard not saved yet. */
    timecardId: number | null;
    /** The text sent to the AI. */
    textBefore: string;
    /** The AI's proposal; null when it proposed no new text. */
    textAfter: string | null;
}

export type FeedbackCreateDto = ChatFeedbackCreateDto | ImproveFeedbackCreateDto;

export interface FeedbackResponseDto {
    id: number;
    employeeId: number;
    source: FeedbackSource;
    aiChatMessageId: number | null;
    sentiment: string;
    category?: string;
    comment?: string;
    createdAt: string;
}

export interface UserFeedbackProps {
    aiChatMessageId: number;
    onSubmitSuccess?: () => void;
}
